<template>
    <div class="products__list">

        <ProductCard v-for="product in productsArray" :key="product.id" :productObject="product" :type="type" :addvisible="addvisible" :removeIsVisible="removeIsVisible"/>

    </div>
</template>

<script>
import ProductCard from "./ProductCard";

    export default {
        name:"ProductGrid",
        props: {
            productsArray: Array,
            type:String,
            addvisible:Boolean,
            removeIsVisible:Boolean,
        },
        components: {
            ProductCard
        },


    }
</script>

<style lang="scss" scoped>
.products__list{
    display: flex;
    flex-wrap: wrap;
}
</style>